module.exports = __webpack_public_path__ + "img/0x45488C50184Ce2092756ba7CdF85731fD17e6f3d.fca1e968.png";